import React from "react";
import { Navigate, RouterProvider } from "react-router";
import { createBrowserRouter } from "react-router-dom";
import Login from "./pages/Login";
import PlatformLayout from "./platform/PlatformLayout";
import PlatformDashboard from "./platform/pages/PlatformDashboard";
import MoMt from "./platform/pages/MoMt";
import Purchases from "./platform/pages/Purchases";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/page/AdminDashboard";
import AdminPurchases from "./admin/page/AdminPurchases";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Navigate to={"/login"} />,
    },
    {
      path: "/admin",
      element: <AdminLayout />,
      children: [
        {
          index: true,
          element: <AdminDashboard />,
        },
        {
          path: "dashboard",
          element: <AdminDashboard />,
        },
        {
          path: "purchases",
          element: <AdminPurchases />,
        },
      ],
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/platform",
      element: <PlatformLayout />,
      children: [
        {
          index: true,
          element: <PlatformDashboard />,
        },
      ],
    },
    {
      path: "/momt",
      element: <PlatformLayout />,
      children: [
        {
          index: true,
          element: <MoMt />,
        },
      ],
    },
    {
      path: "/purchases",
      element: <PlatformLayout />,
      children: [
        {
          index: true,
          element: <Purchases />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};
export default App;
